import { Link, useNavigate } from "react-router";
import { Button } from "../../../app/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../../app/components/ui/card";
import { InventoryEntryForm } from "../components/InventoryEntryForm";

export function InventoryEntryCreatePage() {
  const navigate = useNavigate();

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-3xl font-semibold text-foreground mb-1">Create inventory entry</h1>
          <p className="text-muted-foreground">Add dealer, reference, and purchased items.</p>
        </div>
        <Button asChild variant="outline">
          <Link to="/inventory">Back</Link>
        </Button>
      </div>

      <Card className="border-0 shadow-sm">
        <CardHeader>
          <CardTitle>Entry details</CardTitle>
          <CardDescription>Dynamic rows support multiple products per entry.</CardDescription>
        </CardHeader>
        <CardContent>
          <InventoryEntryForm onSuccess={() => navigate("/inventory")} />
        </CardContent>
      </Card>
    </div>
  );
}

